import { getPath } from '@/router/common'

const baseUrl = {
  title: '回单管理',
  path: 'ReceiptManagement'
}

export default [
  {
    path: getPath('NewHandle', baseUrl),
    name: 'NewHandle',
    component: () => import(/* webpackChunkName: "NewHandle" */ '@/views/receiptManagement/newHandle/index.vue'),
    meta: {
      title: '反签收'
    }
  }
]
